import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from '../../components/components.module';
import { EventTypeSelectorComponent } from './_components/event-type-selector/event-type-selector.component';
import { NgxFileDropModule } from 'ngx-file-drop';
import { LocationSelectorAzureComponent } from './_components/location-selector-azure/location-selector-azure.component';
import { SimilarEventsDialogComponent } from './_components/similar-events-dialog/similar-events-dialog.component';
import { PriceDialogComponent } from './_components/price-dialog/price-dialog.component';
import { TwoDigitDecimalNumberDirective } from 'src/app/directives/two-digit-decimal-number.directive';
import { EditContentButtonComponent } from './edit-content-button/edit-content-button.component';
import { NewEventFormComponent } from './new-event-form/new-event-form.component';
import { MediaUploadStepComponent } from './steps/media-upload-step/media-upload-step.component';
import { LocationSelectionStepComponent } from './steps/location-selection-step/location-selection-step.component';
import { CreateEventFormStore } from './new-event-form/_services/create-event-form-store.service';
import { DetailsStepComponent } from './steps/details-step/details-step.component';
import { CategorySelectionStepComponent } from './new-event-form/steps/category-selection-step/category-selection-step.component';
import { AdditonalDetailsStepComponent } from './steps/additonal-details-step/additonal-details-step.component';
import { PricingStepComponent } from './steps/pricing-step/pricing-step.component';
import { SubmitStepCreateEventComponent } from './new-event-form/steps/submit-step-create-event/submit-step-create-event.component';
import { LocationSelectorService } from './_components/location-selector-azure/service/location-selector.service';
import { BlurWarningDialogComponent } from './steps/additonal-details-step/blur-warning-dialog/blur-warning-dialog.component';
import { BooleanSelectorComponent } from './_components/boolean-selector/boolean-selector.component';
import { EditEventFormComponent } from './edit-event-form/edit-event-form.component';
import { EditEventFormStore } from './edit-event-form/_services/edit-event-form-store.service';
import { SubmitStepEditEventComponent } from './edit-event-form/steps/submit-step-edit-event/submit-step-edit-event.component';

@NgModule({
  declarations: [
    NewEventFormComponent,
    EventTypeSelectorComponent,
    LocationSelectorAzureComponent,
    SimilarEventsDialogComponent,
    EditContentButtonComponent,
    PriceDialogComponent,
    TwoDigitDecimalNumberDirective,
    MediaUploadStepComponent,
    LocationSelectionStepComponent,
    DetailsStepComponent,
    CategorySelectionStepComponent,
    AdditonalDetailsStepComponent,
    PricingStepComponent,
    SubmitStepCreateEventComponent,
    BlurWarningDialogComponent,
    BooleanSelectorComponent,
    EditEventFormComponent,
    SubmitStepEditEventComponent
  ],
  imports: [CommonModule, ComponentsModule, NgxFileDropModule],
  exports: [
    NewEventFormComponent,
    LocationSelectorAzureComponent,
    EditContentButtonComponent,
    EditEventFormComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [CreateEventFormStore, EditEventFormStore, LocationSelectorService]
})
export class CreateEventModule { }
